export default __webpack_public_path__ + "static/media/van.b816e553.svg";